import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, tap, throwError } from 'rxjs';
import { ClientDTO, ExportInterfaceFieldValueReplacementClient, ExportInterfaceFieldValueReplacementEntryDTO, ExportInterfaceSaveFieldValueReplacementsDTO } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class FieldValueReplacementService {

  constructor(private fieldValueReplacementClient: ExportInterfaceFieldValueReplacementClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService) { }

  public clientsHavingReplacements: ClientDTO[] = [];

  public getFieldValueReplacementClients(): Observable<ClientDTO[]> {
    return this.fieldValueReplacementClient.getClientsWithFieldValueReplacements().pipe(
      tap((clients: ClientDTO[]) => {
        this.clientsHavingReplacements = clients;
      }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    )
  }

  public getSourceFieldsWithFieldValueReplacements(clientId: number): Observable<string[]> {
    return this.fieldValueReplacementClient.getSourceFieldsWithFieldValueReplacements(clientId).pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    );
  }

  public getFieldValueReplacementEntriesForSourceField(clientId: number, sourceField: string): Observable<ExportInterfaceFieldValueReplacementEntryDTO[]> {
    return this.fieldValueReplacementClient.getFieldValueReplacementEntriesForSourceField(clientId, sourceField).pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    );
  }

  public saveFieldValueReplacements(fieldValueReplacements: ExportInterfaceSaveFieldValueReplacementsDTO): Observable<void> {
    this.spinnerService.show();
    return this.fieldValueReplacementClient.saveFieldValueReplacements(fieldValueReplacements).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.export-configuration.field-value-replacements.save-success-title',
          'i18n.domain.export-configuration.field-value-replacements.save-success-message');
      }),
      finalize(() => this.spinnerService.hide()),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    );
  }

  public deleteAllFieldValueReplacementsForClient(clientId: number): Observable<void> {
    this.spinnerService.show();
    return this.fieldValueReplacementClient.deleteAllFieldValueReplacementsForClient(clientId).pipe(
      finalize(() => this.spinnerService.hide()),
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.export-configuration.field-value-replacements.delete-success-title',
          'i18n.domain.export-configuration.field-value-replacements.delete-success-message');
      }),
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
        }
        return throwError(() => error);
      }),
    );
  }
}
